<template>
  <ECharts
    ref="eChartRef"
    :autoresize="true"
    :option="chartOption"
    :style="`width: 100%; min-height: ${chartHeight}px; height: 100%`"
  />
</template>

<script setup>
import { defineProps, onMounted, ref, watch } from 'vue';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/scatter';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/markArea';
import 'echarts/lib/component/toolbox';
import { useChart } from '@/composables/useChart.js';
import i18n from '@/i18n';

const props = defineProps({
  chartOption: {
    type: Object,
    default: () => {}
  },
  chartHeight: {
    type: Number,
    default: 0
  },
  configItem: {
    type: Object,
    default: () => {}
  }
});

const { setNothingChart } = useChart();
const eChartRef = ref(null);
const t = (text) => {
  return i18n.global.t(text);
};
const customCss = [
  {
    type: 'image',
    top: '30%',
    left: '45%',
    style: {
      image: require('@/assets/img/scmp/no_data.png')
    },
    z: 10
  },
  {
    type: 'text',
    top: '55%',
    left: '25%',
    style: {
      text: t('label.noData'),
      fill: '#aaa',
      fontFamily: '"Noto Sans KR", Arial, sans-serif',
      fontSize: 14,
      fontWeight: 400,
      color: '#737a8c'
    },
    z: 5
  }
];

onMounted(() => {
  if (eChartRef.value) {
    eChartRef.value.chart.on('legendselectchanged', (params) => {
      setNothingChart(params, eChartRef.value.chart, customCss);
    });
  }
});

watch(
  () => props.configItem,
  () => {
    if (eChartRef.value) {
      eChartRef.value.chart.resize();
    }
  },
  { deep: true }
);
</script>